import { useCallback } from 'react';
import useAsync from './useAsync';
import { browseNovels } from '../services/novelsApi';
import { getGenres } from '../services/genresApi';
import { getTags } from '../services/tagsApi';
import { getContentWarnings } from '../services/contentWarningsApi';

const fetchLibraryData = async (params) => {
  const [novelsPage, genres, tags, contentWarnings] = await Promise.all([
    browseNovels(params),
    getGenres(),
    getTags(),
    // Non-fatal: if the warnings vocabulary can't be fetched the library
    // still loads — the filter panel just hides the warning list.
    getContentWarnings().catch(() => []),
  ]);

  return { novelsPage, genres, tags, contentWarnings };
};

const useLibraryData = ({ params, immediate = true } = {}) => {
  const fetcher = useCallback(() => fetchLibraryData(params), [params]);
  return useAsync(fetcher, { immediate });
};

export default useLibraryData;
